import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export var useCanvasCtx = function useCanvasCtx() {
  var chartCanvasRef = React.useRef(null);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    chartCtx = _React$useState2[0],
    setChartCtx = _React$useState2[1];
  React.useEffect(function () {
    // Сохраняем canvas context в стейт
    /* istanbul ignore else */
    if (chartCanvasRef.current) {
      var ctx = chartCanvasRef.current.getContext('2d');
      setChartCtx(ctx);
    }
  }, []);
  return {
    chartCanvasRef: chartCanvasRef,
    chartCtx: chartCtx
  };
};